import type { Comprador } from "@/types/comprador";
import axios from "axios";
import type { Ref } from "vue";
import { reactive, ref } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";

export default function useComprador() {
  const store = useStore(key);
  let lstCompradores: Ref<Comprador[]> = ref([]);

  async function getCompradores(empresa: string) {
    try {
      await axios
        .get(
          store.state.url + "api/Comprador/GetComprador?company=" + empresa,
          {
            headers: {},
          }
        )
        .then((response) => {
          if (response.status == 200) {
            lstCompradores.value = response.data as Comprador[];
          } else {
            console.log(response.statusText);
          }
        })
        .catch(function (error) {
          console.log(error.message);
        });
    } catch (error) {
      console.log(error);
    }
  }

  return { getCompradores, lstCompradores };
}
